import React from 'react'

import { CollectionDatePicker } from '@src/components/DatePicker/CollectionDatePicker'
import { DeliveryDatePicker } from '@src/components/DatePicker/DeliveryDatePicker'
import { BottomSheet } from '@src/components/BottomSheet/BottomSheet'
import {
  MobileNavigationPopoverContent,
  MobileNavigationPopoverContentWrapper,
} from '@src/components/BottomSheet/BottomSheet.styles'
import { SingleOutletWithDeliveryWindows } from '@src/components/SingleOutlet/types'
import { PopoverFooter } from '@src/components/SiteHeader/ServiceNavigation/Popovers/PopoverFooter'
import { NarrowFulfilmentMethodInputType } from '@src/graphql-types'
import { ExtendedNonBasketOutletFulfilment } from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/extendData/types'
import { useBottomSheetStack } from '../../../../hooks/useBottomSheetStack/useBottomSheetStack'

export const TimePopover: React.FC<{
  outlet: Pick<
    SingleOutletWithDeliveryWindows,
    | 'closedUntil'
    | 'prepTime'
    | 'ASAPDeliveryDuration'
    | 'openingTimesArray'
    | 'isOpen'
    | 'asapAllowed'
    | 'collectionPreorderTimes'
    | 'deliveryPreorderWindows'
    | 'daysOfferedInAdvanceMinDelivery'
    | 'daysOfferedInAdvanceMaxDelivery'
    | 'daysOfferedInAdvanceMinCollection'
    | 'daysOfferedInAdvanceMaxCollection'
  >
  currentFulfilment: ExtendedNonBasketOutletFulfilment['currentFulfilment']
}> = ({ outlet, currentFulfilment }) => {
  const { timePickerBottomSheetController } = useBottomSheetStack()
  return (
    <BottomSheet
      bottomSheetController={timePickerBottomSheetController}
      maxWidth={584}
      showBackdrop={false}
    >
      <MobileNavigationPopoverContentWrapper>
        <MobileNavigationPopoverContent>
          {currentFulfilment.narrowType ===
            NarrowFulfilmentMethodInputType.DELIVERY && (
            <DeliveryDatePicker
              outletData={outlet}
              currentFulfilment={currentFulfilment}
            />
          )}
          {currentFulfilment.narrowType ===
            NarrowFulfilmentMethodInputType.COLLECTION && (
            <CollectionDatePicker
              outletData={outlet}
              currentFulfilment={currentFulfilment}
            />
          )}
        </MobileNavigationPopoverContent>
      </MobileNavigationPopoverContentWrapper>
      <PopoverFooter
        onCancel={timePickerBottomSheetController.close}
        onDone={timePickerBottomSheetController.close}
      />
    </BottomSheet>
  )
}
